<template>
  <div class="box">
    <article class="media">
      <div class="media-content">
        <div class="content">
          <p>
            <strong>Olá, {{person.name}} </strong>
            <br>
            Confira abaixo os seus tickets para o evento
          </p>
          <table class="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Evento</th>
                <th>Tipo</th>
                <th>Quantidade/Usados</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="sale in sales">
                <td>{{sale.id}}</td>
                <td>{{sale.ticket.event.name}}</td>
                <td>{{sale.ticket.name}}</td>
                <td>{{sale.quantity}}/{{sale.guests.length}}</td>
                <td>
                  <a @click="openModal(sale.id)" class="button is-success is-outlined" v-show="sale.guests.length !== sale.quantity" title="adiciona ticket">
                    <span class="icon is-small">
                      <i class="fa fa-ticket"></i>
                    </span></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </article>
    <!-- MODAL -->
    <div class="modal active" v-bind:class="{ 'is-active': showModal }">
      <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Adiciona Ticket</p>
          </header>
          <section class="modal-card-body">
            <form @submit.prevent="validateBeforeSubmit" v-if="!formSubmitted">
              <div class="control">
                <input v-validate="'required'" v-model="participant.name" name="name" type="text" class="input" :class="{'is-danger': errors.has('name') }" placeholder="NOME COMPLETO DO PARTICIPANTE">
                <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
              </div>
              <div class="control">
                <input v-validate="'required|email'" name="email" v-model="participant.email" type="text" class="input" :class="{'is-danger': errors.has('email') }" placeholder="EMAIL">
                <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
              </div>
              <div class="control">
                <input v-validate="'required'" name="phone" v-model="participant.phone" type="text" class="input" :class="{'is-danger': errors.has('phone') }" placeholder="TELEFONE DE CONTATO">
                <span v-show="errors.has('phone')" class="help is-danger">{{ errors.first('email') }}</span>
              </div>
              <div class="control">
                <input v-validate="'required'" name="document" v-model="participant.document" type="text" class="input" :class="{'is-danger': errors.has('document') }" placeholder="NÚMERO DO DOCUMENTO (APENAS NÚMEROS)" onkeypress='return (event.which >= 48 && event.which <= 57) || event.which == 8 || event.which == 0 || event.which == 46'>
                <span v-show="errors.has('document')" class="help is-danger">{{ errors.first('email') }}</span>
              </div>
            <div class="control">
              <select v-validate="'required'" name="gender" class="select" :class="{'is-danger': errors.has('gender') }" v-model="participant.gender">
                <option value="-1">Sexo</option>
                <option value="0" >Feminino</option>
                <option value="1" >Masculino</option>
              </select>
            </div>
            <div class="control">
              <button class="button is-info" @click="createParticipant()" v-bind:class="{'is-disabled': errors.length > 0}" type="submit">Salvar</button>
              <a class="button" @click="showModal = false">Cancel</a>
            </div>
          </form>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sales: [],
      person: {},
      canCreate: {disabled: true, modal: ''},
      purchases: [],
      participant: {gender: -1, ticket:{id: -1}},
      showModal: false,
      saleId: '',
      formSubmitted: false
    }
  },
  mounted: function() {
    this.listSale()
  },
  methods: {
    validateBeforeSubmit(e) {
      this.$validator.validateAll();
      if (!this.errors.any()) {
          this.submitForm()
      }
    },
    submitForm(){
      this.formSubmitted = true
    },
    listSale() {
      this.person = JSON.parse(localStorage.getItem("data"))

      let query = {
        "query": `{
          sales_active_by_event(person: ${this.person.id}, event: ${process.env.EVENT_ID}) {
            id
            quantity
            is_free
            ticket {
              id
              name
              observation
              event {
                id
                name
                description
                start_date
                end_date
                start_hour
                end_hour
                address
              }
            }
            guests {
              person {
                id
                name
              }
            }
          }
        }`
      }

      this.$http.post(process.env.API_URL, query).then((response) => {
        this.sales = response.body.data.sales_active_by_event;
      },
      (response) => {
        console.log(response);
      })
    },
    openModal(saleId){
      this.saleId = saleId
      this.showModal = true
    },
    createParticipant(){
      let person = {
        "query": `mutation createPerson {
          createPerson(input: {
            name: "${this.participant.name}"
            email: "${this.participant.email}"
            document: "${this.participant.document}"
            gender: ${this.participant.gender}
            observation: ""
            phone: "${this.participant.phone}"
            person_category_id: 1
            }){
            person {
              id
              name
              email
              document
              gender
              observation
              phone
              central_user_id
              type {
                id
                name
              }
            }
            message
          }
        }`
      }

      this.getPerson(this.participant.document).then((response) => {
        let personId;
        if(!response){
          this.$http.post(process.env.API_URL, person).then((response) => {
            personId = response.body.data.createPerson.person.id
            this.saveParticipant(personId)
          })
        }else{
          personId = response.id
          this.saveParticipant(personId)
        }
      })
    },
    saveParticipant(personId){
      let event = JSON.parse(localStorage.getItem("event"))
      let participant = {
        "query": `mutation createParticipant {
          createParticipant(input: {
            observation: ""
            sale_id: ${this.saleId}
            event_id: ${event.id}
            person_id: ${personId}
            status: 1
          }){
            participant {
              observation
            }
          }
        }`
      }

      this.getParticipant(event.id, personId).then((response) => {
        if(!response){
          this.$http.post(process.env.API_URL, participant).then((response) => {
            this.showModal = false
            location.reload()
          })
        }else{
          console.log("participante já cadastrado")
        }
      })
    },
    getPerson(document){
      let query = {
        "query": `{
          person_by_document(document: "${document}"){
            id
            name
            email
            document
            gender
            observation
            phone
          }
        }`
      }

      return this.$http.post(process.env.API_URL, query).then((response) => {
        return response.body.data.person_by_document
      })
    },
    getParticipant(eventId, personId){
      let query = {
        "query": `{
          participant(event_id: ${eventId}, person_id: ${personId}){
            person{
              id
              name
            }
          }
        }`
      }

      return this.$http.post(process.env.API_URL, query).then((response) => {
        return response.body.data.participant
      })
    }
  }
}
</script>

<style>
html {
  background-color: rgb(44, 51, 56) !important;
}
</style>



// WEBPACK FOOTER //
// Purchases.vue?74429d44